import axios from "axios";
import {jwtDecode} from "jwt-js-decode";
import {sessionMessageService} from "./_services/sessionMessage.service";
const ACCESS_TOKEN_KEY = "jwtAccessToken";
const REFRESH_TOKEN_KEY = "jwtRefreshToken";
const HAS_TO_CHANGE_PASSWORD = "hasToChangePassword";

class Authentication {

    async login(username, password) {
        return await axios.post(`/api/v1/authenticate`, {
            username: username,
            password: password
        }).then( (response) => {
            sessionStorage.setItem(ACCESS_TOKEN_KEY, response.data.access_token);
            sessionStorage.setItem(REFRESH_TOKEN_KEY, response.data.refresh_token);
            response.data.hasToChangePassword && sessionStorage.setItem(HAS_TO_CHANGE_PASSWORD, '1');
            sessionMessageService.idleTimerTimeout({'logout': false});
            return response;
        });
    }

    getNewToken() {
        return new Promise((resolve, reject) => {
            axios.post(`/api/v1/refresh-token`, {
                refreshToken: this.getRefreshToken()
            }).then((response) => {
                sessionStorage.setItem(ACCESS_TOKEN_KEY, response.data.access_token);
                sessionStorage.setItem(REFRESH_TOKEN_KEY, response.data.refresh_token);
                sessionMessageService.idleTimerTimeout({'logout': false});
                resolve(response.data.access_token);
            }).catch((error) => {
                reject(error);
            });
        });
    }

    async passwordReset(email) {
        return await axios.post(`/api/v1/password-reset`, {
            email: email
        }).then(response => response.data);
    }

    async checkPasswordToken(token) {
        return await axios.get(`/api/v1/password-reset?token=${token}`)
            .then(response => response.data);
    }

    async setPassword(password, token) {
        return await axios.put(`/api/v1/password-reset`, {
            password: password,
            token: token
        }).then(response => response.data);
    }

    getToken() {
        return sessionStorage.getItem(ACCESS_TOKEN_KEY);
    }

    getRefreshToken() {
        return sessionStorage.getItem(REFRESH_TOKEN_KEY);
    }

    getUserId() {
        return jwtDecode(sessionStorage.getItem(ACCESS_TOKEN_KEY)).payload.id;
    }

    getUserName() {
        return jwtDecode(sessionStorage.getItem(ACCESS_TOKEN_KEY)).payload.sub;
    }

    getUserLname() {
        return jwtDecode(sessionStorage.getItem(ACCESS_TOKEN_KEY)).payload.lname;
    }

    getUserFname() {
        return jwtDecode(sessionStorage.getItem(ACCESS_TOKEN_KEY)).payload.fname;
    }

    getUserRoles() {
        const token = sessionStorage.getItem(ACCESS_TOKEN_KEY);
        return !!token && jwtDecode(token).payload.roles;
    }

    getUserRole(roleName) {
        if (this.getUserRoles()) {
            const role = this.getUserRoles().filter(item => item === roleName);
            if (role.length > 0)
                return role[0];
            return '';
        }
        return '';
    }

    isDomainUser() {
        return jwtDecode(sessionStorage.getItem(ACCESS_TOKEN_KEY)).payload.domain;
    }

    logout() {
        sessionStorage.removeItem(ACCESS_TOKEN_KEY);
        sessionStorage.removeItem(REFRESH_TOKEN_KEY);
        sessionStorage.removeItem(HAS_TO_CHANGE_PASSWORD);
        sessionMessageService.idleTimerTimeout({'logout': true});
    }

    loggedIn() {
        const token = this.getRefreshToken();
        return !!token && !this.isRefreshTokenExpired();
    }

    isExpired(token) {
        try {
            const decoded = jwtDecode(token);
            if (decoded.payload.exp < Date.now() / 1000) { // Checking if token is expired. N
                return true;
            }
            return false;
        } catch(err) {
            console.error(err);
            return false;
        }
    }

    isTokenExpired() {
        const token = this.getToken()
        return token === null ? false : this.isExpired(token);
    }

    isRefreshTokenExpired() {
        const token = this.getRefreshToken();
        return token === null ? false : this.isExpired(token);
    }

    getTokenExp() {
        const token = this.getToken();

        if (token) {
            return jwtDecode(token).payload.exp;
        }
        return undefined;
    }

    getRefreshTokenExpiration() {
        const token = this.getRefreshToken();

        if (token) {
            return jwtDecode(token).payload.exp;
        }
        return undefined;
    }

    hasToChangePassword() {
        return sessionStorage.getItem(HAS_TO_CHANGE_PASSWORD) === '1';
    }
    removeHasToChangePassword() {
        sessionStorage.removeItem(HAS_TO_CHANGE_PASSWORD);
    }
    
}

const auth = new Authentication();

export default auth;